export default (theme) => ({
    root: {
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 20px',
        height: 64,
        left: 90,
        right: 0,
        zIndex: 10,
        backgroundColor: theme.colors.primary.white,
    },
    closeIcon: {
        '& svg': {
            '& path': {
                fill: theme.colors.primary.black,
            },
        },
    },
});
